import React from "react";

function About () {
    return (
        <div>About us</div>
    )
}

export default About;